import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import _ from 'lodash'

import CourseWrapper from "../../../../components/_ead/_courseList/CourseWrapper"
import CourseList from "../../../../components/_courses/CourseList"
import MCEadTitle from "../../../../components/_ead/Title"
import PersonRequests from "../../../../requests/person-requests"
import ReleaseRequests from "../../../../requests/release-requests"
import EadRequests from "../../../../requests/ead-requests"
import MCLoadingOverlay from "../../../../components/_minha-central/LoadingOverlay"


class NRTEadCourseListPage extends Component {

    state = {
        awaiting: true,
        eadAccountList: {}
    }


    componentDidMount() {


        if (this.props.context.cacheEadAccountList) {
            this.setState({
                awaiting: false,
                eadAccountList: this.props.context.cacheEadAccountList
            })
        } else {
            this.getCourseList()
        }

    }


    getCourseList() {

        if (this.props.context.person.legal) {
            return this.setState({awaiting: false})
        }


        const {isTeacher} = this.props.context
        const prsCode = this.props.context.person.code
        const prsType = this.props.context.person.type


        const req = isTeacher ?
            ReleaseRequests.oldSearch({
                active: true,
                prsCodeOwner: prsCode
            }) :
            PersonRequests.getInvoiceAccounts(prsCode)


        req.then(result => {

            let accounts = []

            if (!isTeacher) {
                const invoiceAccounts = result

                accounts = _.flatten(invoiceAccounts.map(iva => iva.account.map(account => ({
                    ...account,
                    isAccount: true
                }))))

            } else {
                accounts = result.map(release => (
                    {
                        code: release.code,
                        status: 'ACTIVE',
                        productReleaseDTO: release,
                        isAccount: false,
                        classType: release.classType,
                        mainImageURL: release.mainImageURL
                    }
                ))
            }

            return Promise.all(
                accounts.map(async account => {

                    const code = account.code
                    const release = account.productReleaseDTO

                    const title = release.name
                    const startDate = release.startDate
                    const endDate = release.endDate
                    const classType = release.productDTO.classType
                    const image = release.mainImageURL || release.productDTO.mainImageURL
                    const workload = release.workload

                    // Para estar ativo ou compra tem de estar ativa, ou o status deve ter sido forcado ativo no sistema.
                    const active = (
                        account.status === 'ACTIVE' || (account.status === 'INACTIVE' && !!account.forcedStatus && account.forcedStatus === 'ACTIVE')
                    )

                    let progress = null
                    if (account.isAccount) {
                        // VIRTUAL
                        if (classType === 2) {
                            const result = await EadRequests.getUserProgress(prsCode, account.code)
                            progress = (result * 100) > 100 ? 100 : result * 100
                        }
                    }

                    return {
                        code,
                        title,
                        startDate,
                        endDate,
                        classType,
                        image,
                        progress,
                        workload,
                        active,
                        isAccount: account.isAccount
                    }
                })
            )


        })
            .then(eadAccountList => {

                this.props.context.set({
                    cacheEadAccountList: eadAccountList
                })

                this.setState({
                    eadAccountList,
                    awaiting: false
                })

            })
            .catch(error => {

                this.props.context.logError(error)

                this.props.context.set({
                    toastMessage: {
                        type: 'error',
                        content: 'Ocorreu um erro inesperado.'
                    }
                })
            })

    }


    goToCoursePage = (accountCode) => this.props.history.push(`/conta/curso/${accountCode}`)


    render() {


        const {
            awaiting,
            eadAccountList
        } = this.state

        const isLegal = this.props.context.person.legal

        return (
            <div>

                <MCLoadingOverlay show={awaiting}/>
                <MCEadTitle title={'Meus Cursos'}/>

                {
                    isLegal ?

                        <div style={{textAlign: 'center', fontSize: '1rem'}}>
                            <h3 style={{opacity: .7}}>
                                O acesso aos cursos somente pode ser feito por seus participantes.
                            </h3>
                        </div>
                        :
                        <CourseList>


                            {
                                !awaiting && !eadAccountList &&
                                <div>Você não possui inscrições no momento</div>
                            }

                            {
                                !awaiting &&
                                eadAccountList &&
                                eadAccountList.map(account => {

                                    // patch para liberar p todo mundo do schema gestaoabriem
                                    const schema =  _.get(this.props, 'context.credentials.schema' , '')
                                    const active = schema === 'gestaoabriem' || account.active

                                    return <CourseWrapper key={"prl_" + account.code}
                                                          id={account.code}

                                                          onClick={this.goToCoursePage}
                                                          {...account}
                                                          active={active}


                                                          person={this.props.context.person}
                                    />
                                })
                            }
                        </CourseList>
                }

            </div>
        )
    }
}

NRTEadCourseListPage.propTypes = {
    context: PropTypes.object.isRequired,
}

NRTEadCourseListPage.defaultProps = {}


export default NRTEadCourseListPage



// WEBPACK FOOTER //
// ./src/_pages/Account/_pages/CourseList/index.js